import jquery from "jquery";
window.jQuery = jquery;
window.$ = jquery;

// $(function() {
//   console.log('Jquery is initialized');
// });
